export function updateCannedMessageQueues (queues) {
  return {
      type: 'UPDATE_CannedMessageQueues',
      cannedMessageQueues: queues
  }
}

export function updateSelectedCannedMessageQueue(queueId) {
  return {
      type: 'UPDATE_SelectedCannedMessageQueue',
      selectedCannedMessageQueue: queueId
  }
}

export function addCannedMessage(cannedMessage) {
  return {
      type: 'ADD_CannedMessage',
      currentCannedMessage: cannedMessage
  }
}

export function updateCannedMessage(cannedMessage) {
  return {
      type: 'UPDATE_CannedMessage',
      currentCannedMessage: cannedMessage
  }
}

export function deleteCannedMessage(cannedMessage) {
  return {
      type: 'DELETE_CannedMessage',
      currentCannedMessage: cannedMessage
  }
}
